<span placement="bottom" container="body">
  <span class="emoji" (click)="feedBack(false)"
      [ngClass]="{'emoji-disapear': status==='good', 'emoji-move-right': status==='bad'}">

    <ng-container *ngIf="clicked && status==='bad'">
      <i *ngIf="!rewarded" class="bonus"></i>
      <i *ngIf="rewarded" class="bonus-qoala"></i>
    </ng-container>
    <i class=" icon bad">
    </i>
  </span>
  <span class="emoji" (click)="feedBack(true)"
      [ngClass]="{'emoji-disapear': status==='bad', 'emoji-move-left': status==='good'}">

    <ng-container *ngIf="clicked && status==='good'">
      <i *ngIf="!rewarded" class="bonus"></i>
      <i *ngIf="rewarded" class="bonus-qoala"></i>
    </ng-container>
    <i class=" icon good"></i>
  </span>
</span>